import { render, staticRenderFns } from "./FormGeneral.vue?vue&type=template&id=2e25f6ae&scoped=true&"
import script from "./FormGeneral.vue?vue&type=script&lang=js&"
export * from "./FormGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25f6ae",
  null
  
)

export default component.exports